import { tm } from '../../../tm'
import { Icon } from '../../../Icon'
import i18n from '../i18n'
import type { Locales } from '@captaincause/types'

interface PointValueProps {
  value: string
  className?: string
  locale: Locales
}
export function PointValue({ value, locale, className = '' }: PointValueProps) {
  const t = i18n[locale] ?? i18n.fr

  return (
    <div
      className={tm(
        'flex w-full items-center space-x-1 pr-[120px] text-sm font-medium leading-5 -tracking-[0.14px] text-white',
        className,
      )}
    >
      <Icon size="small" icon="tag" fill="fill-white" className="-mb-1 mr-1" />{' '}
      {value} {t.points}
    </div>
  )
}
